import React, { createContext, useContext, useState } from 'react';
import { useRouteFiltering } from '../useRouteFiltering';

const PlanMapPropsContext = createContext({
    planStops: [],
    routesLevelData: [],
    handleLoadingData: () => {},
    editPermissions: false
});

export const usePlanMapPropsContext = () => useContext(PlanMapPropsContext);

export const PlanMapPropsContextProvider = ({
    children,
    planStops = [],
    routesLevelData = [],
    handleLoadingData = () => {},
    editPermissions = false
}) => {
    const [mapInstance, setMapInstance] = useState(null);
    const [mapsAPI, setMapsAPI] = useState(null);

    const { visibleOnMapRouteData } = useRouteFiltering({
        routesLevelData
    });

    return (
        <PlanMapPropsContext.Provider
            value={{
                planStops,
                routesLevelData,
                visibleOnMapRouteData,
                handleLoadingData,
                editPermissions,
                mapInstance,
                setMapInstance,
                mapsAPI,
                setMapsAPI
            }}
        >
            {children}
        </PlanMapPropsContext.Provider>
    );
};
